import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Text from "@amzn/meridian/esm/components/text";
import Tile from "@amzn/meridian/esm/components/tile";
import { openUrl } from "../../../../utils/zoomSdkUtils";
import { THEME_COLOR } from "../../../../styles/colors";

const truncateUrl = (url, maxLen = 40) => {
  if (!url) return "";
  if (url.length <= maxLen) return url;
  return url.substring(0, maxLen) + "…";
};

const LinkCard = ({ url, title, description }) => {
  const handleClick = () => openUrl(url);

  return (
    <Tile accent={THEME_COLOR.MID_GRAY} spacingInset="none" onClick={handleClick}>
      <Box spacingInset="400">
        <Column spacing="100">
          {title && <Text type="h50">{title}</Text>}
          {description && <Text type="b200" color="secondary">{description}</Text>}
          {url && <Text type="b100" color="secondary">{truncateUrl(url)}</Text>}
        </Column>
      </Box>
    </Tile>
  );
};

export default LinkCard;
